import {Injectable} from '@angular/core';
import {Observable, of, Subject} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {WafCaptchaModalService} from '../../waf-captcha-modal/waf-captcha-modal.service';
import {GlobalDataService} from '../../common/util/globaldata.service';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';

declare const AwsWafCaptcha: any;

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  private static instance: CaptchaService;
  private captchaSubject: Subject<string> | null = null;

  constructor(
    private wafCaptchaModalService: WafCaptchaModalService,
    private gd: GlobalDataService,
    private http: HttpClient
  ) {
    if (!CaptchaService.instance) {
      CaptchaService.instance = this;
    }
    return CaptchaService.instance;
  }

  public handleCaptchaResponse(): Observable<string> {
    if (!this.captchaSubject) {
      this.captchaSubject = new Subject<string>();

      this.getCaptchaKey()
        .pipe(switchMap((captchaKey) => this.captchaRequest(captchaKey)))
        .subscribe({
          next: (token) => this.completeCaptcha(token),
          error: (error) => this.failCaptcha(error)
        });
    }

    return this.captchaSubject.asObservable();
  }

  private getCaptchaKey(): Observable<string> {
    if (this.gd.awsWafCaptchaKey && this.gd.awsWafCaptchaKey !== '') {
      return of(this.gd.awsWafCaptchaKey);
    }
    return this.http.get(`${environment.AWS_WAF_CAPTCHA_API}/?domain=${window.location.host}`)
      .pipe(
        switchMap((body: any) => {
          this.gd.awsWafCaptchaKey = body.captchaKey;
          return of(body.captchaKey);
        })
      );
  }

  private captchaRequest(awsWafCaptchaKey: string): Observable<string> {
    return new Observable<string>((observer) => {
      this.addCaptchaContainer();

      AwsWafCaptcha.renderCaptcha(document.querySelector('#captcha-container'), {
        apiKey: awsWafCaptchaKey,
        onSuccess: (token: string) => {
          this.hideCaptchaContainer();
          observer.next(token);
          observer.complete();
        },
        onError: (error: any) => observer.error(error),
        skipTitle: true
      });
    });
  }

  private completeCaptcha(token: string): void {
    if (this.captchaSubject) {
      this.captchaSubject.next(token);
      this.captchaSubject.complete();
      this.captchaSubject = null;
    }
  }

  private failCaptcha(error: any): void {
    if (this.captchaSubject) {
      this.captchaSubject.error(error);
      this.captchaSubject = null;
    }
  }

  private addCaptchaContainer() {
    const newDiv = document.createElement('div');
    newDiv.setAttribute('id', 'captcha-container');
    this.wafCaptchaModalService.open(newDiv);
  }

  private hideCaptchaContainer() {
    this.wafCaptchaModalService.close();
    const captchaContainer = document.getElementById('captcha-container');
    if (captchaContainer) {
      captchaContainer.style.display = 'none';
    }
  }
}
